import lang from '../../../lang/index.js'

import { StringSchema } from '../../index.js'

export default function base64Image(this: StringSchema) {
  return this
    .matches(/^data:image\/\w+;base64,/, lang().validation.base64ImageInvalid())
}
